<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      @if (!isModal) {
        <ion-button [routerLink]="['/inventory/kegs']">
          <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
        </ion-button>
      }
    </ion-buttons>
    <ion-buttons slot="end">
      @if (isModal) {
        <ion-button (click)="closeModal(item()!)">
          <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
      }
      @if (!isModal) {
        <ion-button (click)="confirmDelete(item()!)" data-testid="keg-detail-delete">
          <ion-icon
            slot="icon-only"
            color="danger"
            name="trash-outline"
          ></ion-icon>
        </ion-button>
        <ion-button (click)="openHelpModal()">
          <ion-icon slot="icon-only" name="help-circle-outline"></ion-icon>
        </ion-button>
	  }
    </ion-buttons>
    <ion-title>
      <span>{{ item()?.name }}</span>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  @if (item() && bar() && units()) {
    <app-form
      [item]="item()!"
      [bar]="bar()!"
      [units]="units()!"
      [uid]="userId()"
      [allBeverages]="beverages()"
      [allTaps]="taps()"
      [allLocations]="locations()"
      (softUpdateKeg)="softUpdateKeg($event)"
      (softUpdateTap)="softUpdateTap($event)"
    ></app-form>
  }
</ion-content>
